import { ImportTheme } from "@template/theme/types/Theme.types.ts";

export default {
  color_algorithm: "auto",
  fontFamily: "dmSans",
  colors: {
    outline: "#8BC7FF",
    base: "#FFFFFF",
    primary: {
      "0": "#ffffff",
      "50": "#fdeaee",
      "100": "#fbd5dd",
      "200": "#f7aabc",
      "300": "#f3809a",
      "400": "#ef5579",
      "500": "#eb2b57",
      "600": "#d41440",
      "700": "#aa1033",
      "800": "#7f0c27",
      "900": "#55081a",
      "950": "#400613",
      "default": "#EA1B4B",
    },
    secondary: {
      "0": "#ffffff",
      "50": "#feebe9",
      "100": "#fdd7d2",
      "200": "#fcb0a5",
      "300": "#fa8879",
      "400": "#f9614c",
      "500": "#f7391f",
      "600": "#e02208",
      "700": "#b31b06",
      "800": "#861505",
      "900": "#5a0e03",
      "950": "#430a02",
      "default": "#F8523B",
    },
    success: {
      "0": "#ffffff",
      "50": "#ebfcf1",
      "100": "#d7f8e4",
      "200": "#b0f1c8",
      "300": "#88ebad",
      "400": "#61e491",
      "500": "#39dd76",
      "600": "#22c65e",
      "700": "#1b9e4b",
      "800": "#147739",
      "900": "#0e4f26",
      "950": "#0a3b1c",
      "default": "#22C55E",
    },
    error: {
      "0": "#ffffff",
      "50": "#ffe9e8",
      "100": "#ffd4d1",
      "200": "#ffa9a2",
      "300": "#ff7d74",
      "400": "#ff5246",
      "500": "#ff2717",
      "600": "#e81000",
      "700": "#b90d00",
      "800": "#8b0900",
      "900": "#5d0600",
      "950": "#460500",
      "default": "#FF3E30",
    },
    default: {
      "0": "#ffffff",
      "50": "#f4f3f3",
      "100": "#e9e8e7",
      "200": "#d2d0cf",
      "300": "#bcb9b7",
      "400": "#a6a29f",
      "500": "#908a87",
      "600": "#78736f",
      "700": "#605c59",
      "800": "#484543",
      "900": "#302e2d",
      "950": "#242221",
      "default": "#423F3D",
    },
  },
  breakpoints: {
    xs: 375,
    sm: 710,
    md: 930,
    lg: 1440,
  },
  content: {
    maxWidth: 1224,
  },
} as ImportTheme;
